import { HttpBackend, HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  BehaviorSubject,
  Observable,
  Subject,
  combineLatest,
  forkJoin,
  of,
} from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataService } from '../data.service';
import { combineAll, delay, filter, map, switchMap, tap } from 'rxjs/operators';
import { AssetType } from './model';

const { version: appVersion } = require('../../../package.json');
declare function require(moduleName: string): any;
import moment from 'moment';
import { NetworthService } from '../networth/networth.service';
import { sectors } from './constants';

@Injectable({
  providedIn: 'root',
})
export class StocksService {
  loggedUser;
  private txSubject = new BehaviorSubject<any>(undefined);
  txSubjectObs = this.txSubject.asObservable().pipe(filter((data) => !!data));
  private memberShipData = new BehaviorSubject<any>(undefined);
  memberShipDataObs = this.memberShipData
    .asObservable()
    .pipe(filter((data) => !!data));
  private adminData = new BehaviorSubject<any>(undefined);
  adminData$ = this.adminData.asObservable().pipe(filter((data) => !!data));
  usedLink = 'stocks';
  mf = 'mf';
  // usedLink='mf'
  lockAdmin = new Subject<boolean>();
  getMappersSub = new BehaviorSubject<any>(undefined);
  getMappersObs: Observable<{}> = this.getMappersSub.asObservable().pipe(
    filter((data) => !!data),
    delay(0)
  );
  getXirrDataSub = new BehaviorSubject<any>(undefined);
  getXirrDataObs = this.getXirrDataSub.asObservable().pipe(
    filter((data) => !!data),
    delay(0)
  );
  getNSEDataSub = new BehaviorSubject<any>(undefined);
  getNSEDataObs = this.getNSEDataSub.asObservable().pipe(
    filter((data) => !!data),
    delay(0)
  );
  getSnapshotSub = new BehaviorSubject<any>(undefined);
  getSnapshotObs = this.getSnapshotSub
    .asObservable()
    .pipe(filter((data) => !!data));
  version;
  localNotifications = [];
  localNotificationsSub = new BehaviorSubject<any>(this.localNotifications);
  localNotificationsObs = this.localNotificationsSub.asObservable();
  fdNotificationDays = 50;
  repeatOrderData = new BehaviorSubject<any>(undefined);
  repeatOrderData$ = this.repeatOrderData
    .asObservable()
    .pipe(filter((data) => !!data));

  expenseDataSub = new BehaviorSubject<any>(false);
  expenseDataObs = this.expenseDataSub.asObservable();
  constructor(
    private HttpClient: HttpClient,
    private dataService: DataService,
    private networthService: NetworthService
  ) {
    // this.dataService.autoLogin().subscribe((data) => {
    //   this.loggedUser = this.dataService.getLoggedUser();
    // });

    this.init();
    this.version = appVersion;
    this.getQuaterNotification();
  }

  init() {
    this.dataService.userLogged$.subscribe((data) => {
      if (data && this.dataService.getLoggedUser().localId) {
        this.loggedUser = this.dataService.getLoggedUser();
        console.log('data got');
        this.triggerAll();
        this.createCombinedData().subscribe(() => {
          console.log('createCombinedData created');
          this.getSectorComp();
          this.getSegmentComp();
        });
      }
    });
    this.adminData$.pipe(filter((data) => !!data)).subscribe((data) => {
      this.fdNotificationDays = +data?.['fdNotificationDays'] || 10;
      this.getData();
    });
  }
  addData(data) {
    return this.HttpClient.post(
      environment.sLnk + `${this.usedLink}/${this.loggedUser.localId}.json`,
      data
    );
  }
  getData() {
    return forkJoin([
      this.HttpClient.get(
        environment.sLnk + `${this.usedLink}/${this.loggedUser.localId}.json`
      ),
    ]).subscribe(([data]) => {
      const mfResult = {};
      // filter data object to not have jsr name stocks
      data = Object.keys(data)
        .filter((key) => data[key].stockName.toLowerCase() !== 'jsr')
        .reduce((obj, key) => {
          obj[key] = data[key];
          return obj;
        }, {});
      for (const m in data) {
        if (data[m].assetType === 'Mutual Fund') {
          data[m] = {
            ...data[m],
            stockName: `${data[m].stockName} (${data[m].portNumber})`,
            charges: 0,
            isMF: true,
            rawData: data[m],
            id: m,
            rawName: data[m].stockName,
            portNumber: data[m].portNumber,
          };
          // if (m !== data[m].id) this.updateData({ id: m }, m).subscribe();
        }

        if (data[m].stockName.toLowerCase().includes('gold')) {
          // console.log('gold mf', data[m]);
          data[m].assetType = 'Gold';
        }

        if (data[m].stockName.includes('_IND')) {
          console.log(data[m].stockName, data[m]);
          data[m].rawName = data[m].stockName;
          data[m].stockName = data[m].stockName.replace('_IND', '');
          data[m].anotherBroker = true;
        }
        // if name is tax entry add adsset type to name
        if (
          data[m].stockName.toLowerCase() === 'tax entry' ||
          data[m].stockName.toUpperCase() === 'ADVANCE TAX ENTRY'
        ) {
          data[m].rawName = `${data[m].stockName}`;
          data[m].stockName = `${data[m].stockName} (${data[m].assetType})`;
        }
        this.checkNotificationPresent(data, m);
      }

      this.txSubject.next({ ...data });
    });
  }

  checkNotificationPresent(data, m) {
    if (
      data[m].assetType === AssetType.FD &&
      data[m]?.maturityDate &&
      this.fdNotificationDays &&
      data[m].txType === 'Buy' &&
      data[m].rawName?.toLowerCase() !== 'tax entry' &&
      data[m].rawName?.toUpperCase() !== 'ADVANCE TAX ENTRY'
    ) {
      if (
        this.getDaysDifference(new Date(), new Date(data[m]?.maturityDate)) <=
        this.fdNotificationDays
      ) {
        this.addNotification({
          message: `${data[m].stockName}(${
            data[m]?.fdNumber
          }) is about to mature in ${this.getDaysDifference(
            new Date(),
            new Date(data[m]?.maturityDate),
            true
          )} days on ${moment(data[m]?.maturityDate).format(
            'dddd DD/MM/yyyy'
          )} amounting to ₹${data[m]?.txPrice}`,
          id: m,
          days: this.getDaysDifference(
            new Date(),
            new Date(data[m]?.maturityDate)
          ),
          fdNumber: data[m]?.fdNumber,
        });
      }
    }
  }
  xirrIds = {};
  addXirrData(data) {
    if (this.xirrIds[data.name]) {
      return this.updateXirrData(data, this.xirrIds[data.name]);
    }
    return this.HttpClient.post(
      environment.sLnk + `stocks-xirr/${this.loggedUser.localId}.json`,
      data
    );
  }

  addNSEData(data) {
    return this.HttpClient.post(
      environment.sLnk + `stocks-nse/${this.loggedUser.localId}.json`,
      data
    );
  }

  updateXirrData(data, id) {
    return this.HttpClient.patch(
      environment.sLnk + `stocks-xirr/${this.loggedUser.localId}/${id}.json`,
      data
    );
  }

  delXirrData(mergeMode = true) {
    if (!mergeMode) {
      return this.HttpClient.delete(
        environment.sLnk + `stocks-xirr/${this.loggedUser.localId}.json`
      );
    } else {
      return of(true);
    }
  }

  delXirrDataById(id) {
    return this.HttpClient.delete(
      environment.sLnk + `stocks-xirr/${this.loggedUser.localId}/${id}.json`
    );
  }

  getXirrData(subscribe = true) {
    const sub = this.HttpClient.get(
      environment.sLnk + `stocks-xirr/${this.loggedUser.localId}.json`
    ).pipe(
      map((data) => {
        const temp = {};
        const usedIdTemp = {};
        let date = new Date().toString().split(' GMT')[0];
        let exchangeRate = 0;
        for (const o in data) {
          temp[data[o]['name']] = data[o]['currValue'];
          usedIdTemp[data[o]['name']] = o;
          date = new Date(data[o]['date']).toString().split(' GMT')[0];
          if (data[o]['exchangeRate']) {
            exchangeRate = data[o]['exchangeRate'];
          }
        }
        const tempInv = {};
        for (const o in data) {
          tempInv[data[o]['name']] = data[o]['invValue'];
        }
        const ids = {};
        for (const o in data) {
          if (!ids[data[o]['name']]) {
            ids[data[o]['name']] = [o];
          } else {
            ids[data[o]['name']].push(o);
          }
        }
        this.xirrIds = usedIdTemp;
        return {
          data: temp,
          date: date,
          invData: tempInv,
          ids,
          usedIdTemp,
          exchangeRate,
        };
      }),
      tap((data) => this.getXirrDataSub.next(data))
    );
    if (subscribe) {
      sub.subscribe();
    } else {
      return sub;
    }
  }

  getNSEData() {
    return this.HttpClient.get(
      environment.sLnk + `stocks-nse/${this.loggedUser.localId}.json`
    )
      .pipe(
        map((data) => {
          const temp = {};

          for (const o in data) {
            temp[moment(data[o]['date']).format('DD/MM/yyyy')] = {
              change: data[o]['change'],
              closingValue: data[o]['closingValue'],
            };
          }

          console.log('nseData', temp);

          return {
            ...temp,
          };
        }),
        tap((data) => this.getNSEDataSub.next(data))
      )
      .subscribe();
  }

  mapName(data) {
    return this.HttpClient.post(
      environment.sLnk + `stocks-mapper/${this.loggedUser.localId}.json`,
      data
    )
      .pipe()
      .subscribe();
  }

  getMappers() {
    return this.HttpClient.get(
      environment.sLnk + `stocks-mapper/${this.loggedUser.localId}.json`
    )
      .pipe(
        map((data) => {
          const temp = {};
          for (const o in data) {
            if (temp[data[o]['name']]) {
              temp[data[o]['name']].push(data[o]['mapped']);
              temp[data[o]['name']] = [...new Set(temp[data[o]['name']])];
            } else {
              temp[data[o]['name']] = [data[o]['mapped'].toUpperCase()];
            }
          }

          return temp;
        }),
        tap((data) => this.getMappersSub.next(data))
      )
      .subscribe();
  }

  saveSnapshot(data) {
    return this.HttpClient.post(
      environment.sLnk + `stocks-snapshot/${this.loggedUser.localId}.json`,
      data
    )
    .pipe(tap(() => this.getSnapshot()));
  }

  getSnapshot() {
    return this.HttpClient.get(
      environment.sLnk + `stocks-snapshot/${this.loggedUser.localId}.json`
    )
      .pipe(
        map((data) => {
          const temp = [];
          for (const o in data) {
            temp.push({ ...data[o], id: o });
          }
          const result = temp.map((d) => {
            const date = d.date.split('T')[0];
            const fdate =
              date.split('-')[2] +
              '/' +
              date.split('-')[1] +
              '/' +
              date.split('-')[0];
            return { ...d, date: fdate, rawDate: d.date };
          });
          return result
            .filter(
              (value) =>
                value.invValue &&
                value.amount &&
                value?.['IND Stocks'].xirr !== '0%'
            )
            .reverse();
        })
      )
      .subscribe((data) => {
        this.getSnapshotSub.next(data);
      });
  }

  updateData(data, id, recall = true) {
    return this.HttpClient.patch(
      environment.sLnk +
        `${this.usedLink}/${this.loggedUser.localId}/${id}.json`,
      data
    )
    .pipe(
      tap((data) => {
        if (recall) {
          this.getData();
        }
      })
    );
  }
  updateSnapshotData(data, id) {
    return this.HttpClient.patch(
      environment.sLnk +
        `stocks-snapshot/${this.loggedUser.localId}/${id}.json`,
      data
    );
  }

  deleteRow(id) {
    return this.HttpClient.delete(
      environment.sLnk +
        `${this.usedLink}/${this.loggedUser.localId}/${id}.json`
    ).pipe(tap(() => this.getData()));
  }

  getTranByAssetTypes() {
    return this.txSubjectObs.pipe(
      map((data) => {
        const temp = {};
        for (const key in data) {
          if (temp[data[key].assetType]) {
            temp[data[key].assetType].push(data[key]);
          } else {
            temp[data[key].assetType] = [data[key]];
          }
        }
        console.log(temp);
        return temp;
      })
    );
  }

  getReoccuringTransactions() {
    return this.txSubjectObs.pipe(
      map((data) => {
        const temp = [];
        for (const key in data) {
          if (data[key].isReoccuring) {
            temp.push(data[key]);
          }
        }
        return temp;
      })
    );
  }

  getAssetTypes(asObject = false) {
    return this.getTranByAssetTypes().pipe(
      map((data) => {
        if (asObject) {
          return Object.keys(data)
            .filter((key) => key !== 'Jsr')
            .map((key) => ({ name: key, value: key }));
        } else {
          return Object.keys(data).filter((key) => key !== 'Jsr');
        }
      })
    );
  }

  getAdminData() {
    return this.HttpClient.get(
      environment.sLnk + `stocks-admin-data/${this.loggedUser.localId}.json`
    ).pipe(tap((data) => this.adminData.next(data)));
  }

  saveAdminData(data) {
    if (data?.['fdNotificationDays']) {
      this.clearNotification();
    }
    return this.HttpClient.patch(
      environment.sLnk + `stocks-admin-data/${this.loggedUser.localId}.json`,
      data
    ).pipe(tap(() => this.getAdminData().subscribe()));
  }

  getAdminDataById(id) {
    return this.HttpClient.get(
      environment.sLnk + `stocks-admin-data/${this.loggedUser.localId}.json`
    ).pipe(map((data) => data[id]));
  }

  resetColors(assetTypes, customData?: any, showMessage = false) {
    assetTypes.forEach((assetType) => {
      if (customData) {
        document.documentElement.style.setProperty(
          '--' + assetType.name.replace(' ', '').toLowerCase(),
          customData[assetType.name]
        );
      }
    });
  }

  triggerAll() {
    console.log('trigger all');
    this.getAdminData().subscribe(() => {
      this.getData();
      // this.getSnapshot();
      this.getMappers();
      this.getXirrData();
      this.getNSEData();
    });
  }
  clearNotification() {
    this.localNotifications = [];
    this.localNotificationsSub.next(this.localNotifications);
  }

  getQuaterNotification() {
    // <li class="  ">Q1: April 1st - June 15th</li>
    // <li>Q2: June 16th - September 15th</li>
    // <li>Q3: September 16th - December 15th</li>
    // <li>Q4-1: December 16th - March 15th</li>
    // <li>Q4-2: March 16th - March 31st</li>
    const today = new Date();
    // create an array with June 15 of current year, Sept 15 of current year, Dec 15 of current year, March 15  and March  31
    const quaterDates = [
      new Date(today.getFullYear(), 5, 15),
      new Date(today.getFullYear(), 8, 15),
      new Date(today.getFullYear(), 11, 15),
      new Date(today.getFullYear(), 2, 15),
      new Date(today.getFullYear(), 2, 31),
    ];
    // lets have this array as an object with propert date and quater
    const quaterDatesObj = [
      { date: quaterDates[0], quater: 'Q1' },
      { date: quaterDates[1], quater: 'Q2' },
      { date: quaterDates[2], quater: 'Q3' },
      { date: quaterDates[3], quater: 'Q4-1' },
      { date: quaterDates[4], quater: 'Q4-2' },
    ];
    console.log(quaterDatesObj);

    quaterDatesObj.forEach((d) => {
      if (this.getDaysDifference(today, d.date) > 0) {
        this.addNotification({
          message: `Due date for ${d.quater} advance tax is ${moment(
            d.date
          ).format('dddd DD/MM/yyyy')} in ${this.getDaysDifference(
            today,
            d.date
          )} days`,
          id: d.quater,
          days: this.getDaysDifference(today, d.date),
        });
      }
    });
  }

  getDaysDifference(date1, date2, sendOrignal = false) {
    if (!date1 || !date2) return 0;
    let differenceInTime = date2.getTime() - date1.getTime();

    let differenceInDays = differenceInTime / (1000 * 3600 * 24);
    // if (differenceInDays < 0) return 0;
    // console.log(differenceInDays);
    return Math.ceil(differenceInDays);
  }

  addNotification(data) {
    if (
      this.localNotifications.find(
        (d) => d.id === data.id || d.fdNumber === data.fdNumber
      ) ||
      data.days < -1
    ) {
      return;
    }
    this.localNotifications.push(data);
    this.localNotifications.sort((a, b) => a.days - b.days);
    this.localNotificationsSub.next(this.localNotifications);
  }

  getNotifications() {
    return this.localNotificationsObs;
  }

  cleanCache() {
    this.networthService.cleanCache();
    this.txSubject.next(undefined);
    this.adminData.next(undefined);
    this.getMappersSub.next(undefined);
    this.getXirrDataSub.next(undefined);
    this.getSnapshotSub.next(undefined);
    this.getNSEDataSub.next(undefined);
  }

  syncProdToDev() {
    this.cleanCache();

    const prodLink =
      'https://stocksdashboards-default-rtdb.firebaseio.com/prod/';
    const devLink = 'https://stocksdashboards-default-rtdb.firebaseio.com/dev/';
    return forkJoin([
      this.HttpClient.get(
        prodLink + `stocks-xirr/${this.loggedUser.localId}.json`
      ),
      this.HttpClient.get(
        prodLink + `stocks-snapshot/${this.loggedUser.localId}.json`
      ),
      this.HttpClient.get(
        prodLink + `stocks-mapper/${this.loggedUser.localId}.json`
      ),
      this.HttpClient.get(
        prodLink + `stocks-admin-data/${this.loggedUser.localId}.json`
      ),
      this.HttpClient.get(prodLink + `stocks/${this.loggedUser.localId}.json`),
      this.HttpClient.get(
        prodLink + `networth/${this.loggedUser.localId}.json`
      ),
      this.HttpClient.get(
        prodLink + `post-data/${this.loggedUser.localId}.json`
      ),
      this.HttpClient.get(
        prodLink + `stocks-nse/${this.loggedUser.localId}.json`
      ),
      this.HttpClient.get(
        prodLink + `expense-data/${this.loggedUser.localId}.json`
      ),
    ]).pipe(
      switchMap(
        ([
          xirr,
          snapshot,
          mapper,
          adminData,
          stocks,
          networth,
          postData,
          nseData,
          expenseData,
        ]) => {
          return forkJoin([
            this.HttpClient.put(
              devLink + `stocks-xirr/${this.loggedUser.localId}.json`,
              xirr
            ),
            this.HttpClient.put(
              devLink + `stocks-snapshot/${this.loggedUser.localId}.json`,
              snapshot
            ),
            this.HttpClient.put(
              devLink + `stocks-mapper/${this.loggedUser.localId}.json`,
              mapper
            ),
            this.HttpClient.put(
              devLink + `stocks-admin-data/${this.loggedUser.localId}.json`,
              adminData
            ),
            this.HttpClient.put(
              devLink + `stocks/${this.loggedUser.localId}.json`,
              stocks
            ),
            this.HttpClient.put(
              devLink + `networth/${this.loggedUser.localId}.json`,
              networth
            ),
            this.HttpClient.put(
              devLink + `post-data/${this.loggedUser.localId}.json`,
              postData
            ),
            this.HttpClient.put(
              devLink + `stocks-nse/${this.loggedUser.localId}.json`,
              nseData
            ),
            this.HttpClient.put(
              devLink + `expense-data/${this.loggedUser.localId}.json`,
              expenseData
            ),
          ]);
        }
      ),
      tap(() => this.triggerAll())
    );
  }

  sentRepeatORder(data) {
    this.repeatOrderData.next(data);
  }

  getMemberShipData() {
    return forkJoin([
      this.HttpClient.get(
        environment.sLnk + `post-data/${this.loggedUser.localId}.json`
      ),
    ]).subscribe(([data]) => {
      let newData = [];
      for (const d in data) {
        newData.push(data[d][Object.keys(data[d])[0]]);
      }
      this.memberShipData.next(newData);
    });
  }

  addMemberShipData(data) {
    return forkJoin([
      this.HttpClient.post(
        environment.sLnk + `post-data/${this.loggedUser.localId}.json`,
        { [new Date().toISOString().split('T')[0]]: data }
      ),
    ]).subscribe(([data]) => {
      console.log(data);

      this.getMemberShipData();
    });
  }

  getDollarData() {
    return this.HttpClient.get(
      environment.sLnk + `dollar-data/${this.loggedUser.localId}.json`
    ).pipe(
      map((data) => {
        const temp = [];

        for (const o in data) {
          temp.push({
            ...data[o],
            id: o,
            date: moment(new Date(data[o].date)).format('DD/MM/yyyy'),
            rawDate: data[o].date,
          });
        }

        console.log('getDollarData', temp);

        return temp;
      })
    );
  }
  addDollarData(data) {
    return this.HttpClient.post(
      environment.sLnk + `dollar-data/${this.loggedUser.localId}.json`,
      data
    );
  }

  getExpenseData() {
    return this.HttpClient.get(
      environment.sLnk + `expense-data/${this.loggedUser.localId}.json`
    ).pipe(
      map((data) => {
        const temp = [];

        for (const o in data) {
          temp.push({
            ...data[o],
            id: o,
          });
        }
        // sort based on year field which in format of Feb-23 likewise

        temp.sort((a, b) => {
          const dateA = moment(a.year, 'MMM-YY');
          const dateB = moment(b.year, 'MMM-YY');
          return dateA.isBefore(dateB) ? -1 : dateA.isAfter(dateB) ? 1 : 0;
        });

        return temp;
      })
    );
  }
  addExpenseData(data) {
    return this.HttpClient.post(
      environment.sLnk + `expense-data/${this.loggedUser.localId}.json`,
      data
    );
  }

  addExpensePatchData(data, id) {
    return this.HttpClient.patch(
      environment.sLnk +
        `expense-data/${this.loggedUser.localId}/${id}/data.json`,
      data
    );
  }

  addExpenseAllPatchData(data, id) {
    return this.HttpClient.patch(
      environment.sLnk + `expense-data/${this.loggedUser.localId}/${id}.json`,
      data
    );
  }

  getSegmentTypes() {
    return [
      { name: 'Equity-LC', value: 'Equity-LC' },
      { name: 'Equity-SC', value: 'Equity-SC' },
      { name: 'Equity-MC', value: 'Equity-MC' },
      { name: 'Debt', value: 'Debt' },
      { name: 'Gold', value: 'Gold' },
    ];
  }

  getSectors() {
    return sectors.map((sector) => ({ name: sector, value: sector }));
  }

  saveSectorComp(data) {
    if (this.sectorCompositionIds[data.name]) {
      return this.updateSectorComp(data);
    }
    return this.HttpClient.post(
      environment.sLnk + `sector-comp/${this.loggedUser.localId}.json`,
      data
    );
  }

  updateSectorComp(data) {
    const id = this.sectorCompositionIds[data.name];
    return this.HttpClient.patch(
      environment.sLnk + `sector-comp/${this.loggedUser.localId}/${id}.json`,
      data
    );
  }
  private sectorComposition = new BehaviorSubject<any>(undefined);
  sectorCompositionObs = this.sectorComposition
    .asObservable()
    .pipe(filter((data) => !!data));

  private sectorStockComposition = new BehaviorSubject<any>(undefined);
  sectorStockCompositionObs = this.sectorStockComposition
    .asObservable()
    .pipe(filter((data) => !!data));
  sectorCompositionIds = {};
  getSectorComp() {
    console.log('getSectorComp', this.collatedData);
    const sectors = {};
    return this.HttpClient.get(
      environment.sLnk + `sector-comp/${this.loggedUser.localId}.json`
    )
      .pipe(
        map((data) => {
          if (data) {
            const temp = {};
            console.log('getSectorComp data', data, this.currValXirr);

            for (const o in data) {
              if (this.calculateTotalStocks(data[o].rawName)) {
                temp[data[o].name] = {
                  sectorComposition: data[o].sectorComposition,
                  value: this.getCurrentValue(
                    !data[o].isMf ? data[o].rawName : data[o].name
                  ),
                  available: this.calculateTotalStocks(data[o].rawName),
                  id: o,
                  assetType: data[o].assetType,
                };
                this.sectorCompositionIds[data[o].name] = o;
              }
            }
            this.sectorStockComposition.next(structuredClone(temp));
            console.log('getSectorComp temp', temp);

            for (const t in temp) {
              temp[t].sectorComposition.forEach((s) => {
                if (sectors[s.name]) {
                  sectors[s.name].push({
                    temp: temp[t],
                    perc: +s.perc.replace('%', ''),
                    amount: (+s.perc.replace('%', '') * temp[t].value) / 100,
                    name: t,
                    assetType: temp[t].assetType,
                  });
                } else {
                  sectors[s.name] = [
                    {
                      temp: temp[t],
                      name: t,
                      perc: +s.perc.replace('%', ''),
                      amount: (+s.perc.replace('%', '') * temp[t].value) / 100,
                      assetType: temp[t].assetType,
                    },
                  ];
                }
              });
            }
            console.log('sectors', sectors);

            console.log('sectorsComposition', temp);
            console.log('sectorsCompositionIds', this.sectorCompositionIds);

            return sectors;
          }
        })
      )
      .subscribe((data) => {
        this.sectorComposition.next(sectors);
      });
  }
  // {
  //   console.log('getSectorComp');
  //   return this.HttpClient.get(
  //     environment.sLnk + `sector-comp/${this.loggedUser.localId}.json`
  //   )
  //     .pipe(
  //       map((data) => {
  //         if (data) {
  //           const temp = {};
  //           for (const o in data) {
  //             temp[data[o].name] = data[o].sectorComposition;
  //             this.sectorCompositionIds[data[o].name] = o;
  //           }
  //           console.log('getSectorComp', temp);
  //           console.log('sectorCompositionIds', this.sectorCompositionIds);
  //           return temp;
  //         }
  //       })
  //     )
  //     .subscribe((data) => {
  //       this.sectorComposition.next(data);
  //     });
  // }

  saveSegmentComp(data) {
    if (this.segmentCompositionIds[data.name]) {
      return this.updateSegmentComp(data);
    }
    return this.HttpClient.post(
      environment.sLnk + `segment-comp/${this.loggedUser.localId}.json`,
      data
    );
  }

  updateSegmentComp(data) {
    const id = this.segmentCompositionIds[data.name];
    return this.HttpClient.patch(
      environment.sLnk + `segment-comp/${this.loggedUser.localId}/${id}.json`,
      data
    );
  }

  private segmentComposition = new BehaviorSubject<any>(undefined);
  segmentCompositionObs = this.segmentComposition
    .asObservable()
    .pipe(filter((data) => !!data));
  segmentCompositionIds = {};
  getSegmentComp() {
    console.log('getSegmentComp', this.collatedData);
    const segments = {};
    return this.HttpClient.get(
      environment.sLnk + `segment-comp/${this.loggedUser.localId}.json`
    )
      .pipe(
        map((data) => {
          if (data) {
            const temp = {};
            console.log('segmentComposition data', data, this.currValXirr);

            for (const o in data) {
              // console.log(data[o].name);
              if (
                data[o].name === 'PARAG PARIKH FLEXI CAP GROWTH DIRECT PLAN'
              ) {
                console.log('PARAG PARIKH FLEXI CAP GROWTH DIRECT PLAN');
              }
              temp[data[o].name] = {
                segmentComposition: data[o].segmentComposition,
                value: this.getCurrentValue(
                  !data[o].isMf ? data[o].rawName : data[o].name
                ),
                available: this.calculateTotalStocks(data[o].rawName),
                id: o,
                assetType: data[o].assetType,
              };
              this.segmentCompositionIds[data[o].name] = o;
            }

            for (const t in temp) {
              temp[t].segmentComposition
                .map((s) => {
                  if (s.name === 'Large cap') {
                    s.name = 'Equity-LC';
                  }
                  if (s.name === 'Mid cap') {
                    s.name = 'Equity-MC';
                  }
                  if (s.name === 'Small cap') {
                    s.name = 'Equity-SC';
                  }
                  return s;
                })
                .forEach((s) => {
                  if (segments[s.name]) {
                    segments[s.name].push({
                      temp: temp[t],
                      perc: +s.perc.replace('%', ''),
                      amount: (+s.perc.replace('%', '') * temp[t].value) / 100,
                      name: t,
                      assetType: temp[t].assetType,
                    });
                  } else {
                    segments[s.name] = [
                      {
                        temp: temp[t],
                        name: t,
                        perc: +s.perc.replace('%', ''),
                        amount:
                          (+s.perc.replace('%', '') * temp[t].value) / 100,
                        assetType: temp[t].assetType,
                      },
                    ];
                  }
                });
            }
            console.log('segments', segments);

            console.log('segmentComposition', temp);
            console.log('segmentCompositionIds', this.segmentCompositionIds);

            return segments;
          }
        })
      )
      .subscribe((data) => {
        this.segmentComposition.next(segments);
      });
  }
  collatedData;
  mapperData;
  currValXirr;
  createCombinedData() {
    const collatedData = [];
    return combineLatest([this.getXirrDataObs, this.getMappersObs]).pipe(
      tap(([data, mapper]) => {
        if (data && mapper) {
          this.mapperData = mapper;

          this.currValXirr = data.data;
        }
        this.txSubjectObs.subscribe((data) => {
          if (data) {
            const temp = [];
            for (const key in data) {
              temp.push({
                ...data[key],
                id: key,
                txDate: new Date(data[key].txDate),
              });
            }

            temp.map((item) => {
              if (!item?.sector) {
                return (item.sector = 'Others');
              }
            });

            temp.forEach((item) => {
              if (collatedData[item?.rawName || item.stockName]) {
                collatedData[item?.rawName || item.stockName].push(item);
              } else {
                collatedData[item?.rawName || item.stockName] = [item];
              }
            });
            this.collatedData = collatedData;
          }
        });
      })
    );
  }

  calculateTotalStocks(data) {
    console.log('calculateTotalStocks', data);
    const alltx = this.collatedData?.[data];
    let ts = 0;
    alltx?.forEach((item) => {
      if (item.txType == 'Buy') {
        ts = ts + +item.txQuantity;
      } else if (item.txType == 'Sell') {
        ts = ts - +item.txQuantity;
      }
    });
    return +ts.toFixed(2);
  }

  getCurrentValue(data) {
    let currentValue = 0;
    try {
      currentValue = Number(this.currValXirr?.[data] || 0) || 0;
      if (currentValue === 0) {
        const mapperData = this.mapperData?.[data];
        for (const m of mapperData) {
          currentValue = Number(this.currValXirr?.[m] || 0);
          if (currentValue) break;
        }
        // currentValue = Number(this.currValXirr?.[mapperData] || 0);
      }
    } catch (error) {
      currentValue = 0;
    }

    return currentValue;
  }

  httpBackend = inject(HttpBackend);
  http: HttpClient;
  fetchSecSegData(id, isGold) {
    this.http = new HttpClient(this.httpBackend);

    return this.http
      .get(
        `https://apixt-iw.indmoney.com/mf-tracking-ext/web/v2/funds/${id}/?widget_exclude=polls`
      )
      .pipe(
        map((data: any) => {
          const seg = [];
          const sect = [];
          const res: [] = data.data?.fund_distribution.distribution;
          console.log('data from indmoney', res);
          res.forEach((r: any) => {
            console.log(r);
            if (isGold) {
              sect.push({
                name: 'Gold',
                perc: '100%',
                value: 100,
              });
              seg.push({
                name: 'Gold',
                perc: '100%',
                value: 100,
              });
            } else {
              if (r.name === 'Equity') {
                seg.push(...r.market_cap_distribution.market_cap);
                sect.push(...r.sectors);
              } else if (r.name.includes('Debt')) {
                seg.push({
                  color: '#544CC9',
                  name: 'Debt',
                  perc: r.perc,
                  value: r.PercentageVal,
                });
                sect.push({
                  name: 'Debt',
                  perc: r.perc,
                  value: r.PercentageVal,
                });
              }
            }
          });

          console.log(seg);
          console.log(sect);
          return {
            seg,
            sect,
          };
        })
      );
  }

  saveSegSecSnapshot(data) {
    return this.HttpClient.post(
      environment.sLnk + `sec-seg-snapshot/${this.loggedUser.localId}.json`,
      data
    );
  }

  fetchNSEData() {
    this.http = new HttpClient(this.httpBackend);

    return this.http.get(
      'https://apixt-iw.indmoney.com/wright/api/web/v1/indices/nifty-50'
    );
  }
}
